<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card no-shadow mt-0">
            <div class="
                card-header card-header-primary
                negative
                blue-grad
                w-50
                d-flex
                flex-column
              ">
              <h4 class="card-title">
                {{ $t("message.business_score.title") }}
              </h4>
            </div>
            <div class="card-body w-100 mt-3">
              <b-tabs pills content-class="mt-3" small v-model="tab_index">
                <b-tab :title="$t('message.business_score.search')" active id="search-tab">
                  <div class="mb-3">
                    <input type="number" class="form-control w-25" style="height: 50px" :disabled="isSearching" :placeholder="$t('message.business_score.year')
                        " v-model="searchYear" autocomplete="off" :min="1900" :max="new Date().getFullYear()"  @input="limitYearLength" />
                  </div>

                  <div class="input-group">
                    <input type="text" class="form-control" style="height: 50px" :disabled="isSearching" :placeholder="$t('message.business_score.search_keyword_placeholder')
                      " v-model="searchKeyword" autocomplete="off" />
                    <div class="input-group-append">
                      <button v-if="!isSearching" class="btn btn-primary" type="button" @click="search"
                        style="height: 50px">
                        {{ $t("message.business_score.search") }}
                      </button>
                      <button v-else class="btn btn-primary" type="button" disabled style="height: 50px">
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        {{ $t("message.business_score.searching") }}...
                      </button>
                    </div>
                  </div>
                  <div class="mt-2" v-if="input_error" style="color: red;">{{ $t('message.code_must_be_12_symbols') }}
                  </div>
                  <div class="mt-3">
                    <div v-if="isSearching">
                      <h4>{{ $t("message.business_score.searching") }}...</h4>
                    </div>
                    <div v-else-if="isSearched && !resultsExists">
                      {{ $t("message.business_score.no_results") }}
                    </div>
                    <div v-else-if="isSearched && resultsExists" class="mt-4">
                      <div class="mr-0 ml-auto mb-3" style="width: fit-content">
                        <js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'detail.pdf'">
                          <template v-slot>
                            <!-- Render ItemsList into the PDF -->
                            <ItemsList :data="response.data.items" :imLoaded="pdfProps.childFullyLoaded" />
                          </template>
                        </js-pdf>
                      </div>

                      <!-- Render ItemsList for screen -->
                      <ItemsList :data="response.data.items" />
                    </div>
                    <div></div>
                  </div>
                </b-tab>
                <b-tab :title="$t('message.business_score.history')" lazy id="history-tab">
                  <History />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ItemsList from "./itemsList.vue";
import History from "./history.vue";

export default {
  inject: ["runBiller", "updateBiller"],
  components: { ItemsList, History },
  data() {
    return {
      tab_index: 0,
      isSearching: false,
      isSearched: false,
      searchKeyword: "",
      response: null,
      input_error: false,
      searchYear: null,
    };
  },
  async mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    try {
      const res = await axios.get(window.base + "/account/GetAdminSettings");
      const defaultYear = res.data?.businessScoreDefaultYear;
      if (defaultYear && !this.searchYear) {
        this.searchYear = Number(defaultYear);
      }
    } catch (e) {
      console.error("Load settings error:", e);
    }
  },
  methods: {
    validateSearchKeyword() {
      if (!isNaN(Number(this.searchKeyword)) && ![15, 18].includes(this.searchKeyword.length)) {
        this.input_error = true;
        return false;
      }
      this.input_error = false;
      return true;
    },
    async search() {
      if (!this.validateSearchKeyword()) {
        return;
      }
      const reduceBalanceId = await this.runBiller("400", this.searchKeyword, false);
      if (!reduceBalanceId) {
        return;
      }
      this.isSearching = true;
      this.isSearched = false;
      try {
        var requesUrl = `${window.base}/PersonalLegalInfo/GetBusinessScore`;

        var requestParameters = null;
        if (this.searchYear) {
          requestParameters = {
          company: this.searchKeyword,
          locale: this.$i18n.locale,
          signalRConnectionId: window.signalRConnectionId,
          year: this.searchYear
        };
          } else {
            requestParameters = {
            company: this.searchKeyword,
            locale: this.$i18n.locale,
            signalRConnectionId: window.signalRConnectionId,
            year: this.searchYear
          };
        }

        const res = await axios.post(requesUrl, requestParameters);
        this.response = res.data;
      } catch (e) {
        if (error.message === 'Network Error') {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.request_error_messages.connection_issue"),
            timeout: 5000,
          }).show();
        }
        console.error("Business Score Service Error:", e);
      }
      this.isSearched = true;
      this.isSearching = false;
    },
    limitYearLength(event) {
      const value = event.target.value;
      if (value.length > 4) {
        event.target.value = value.slice(0, 4);
        this.searchYear = event.target.value;
      }

      this.isValidYear();
    },
    isValidYear() {
      if (this.searchYear.length == 4) {
        const year = Number(this.searchYear);
        const currentYear = new Date().getFullYear();
        if (/^\d{4}$/.test(year)) {
          if (year < 1900) {
            this.searchYear = 1900;
          } else if (year > currentYear) {
            this.searchYear = currentYear;
          }
        }
      }
    },
  },
  watch: {
    searchKeyword(newVal) {
      this.input_error = false;
    },
  },
  computed: {
    resultsExists() {
      return Boolean(this.response?.data?.items?.at(0));
    },
  },
};
</script>
<style>
.modal-footer .btn.btn-success.btn-sm:hover {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}

.modal-footer .btn.btn-secondary.btn-sm:hover {
  color: #333333 !important;
}
</style>
